import { useState } from 'hooks'
import M from 'materialize-css'
import { getImportDatamapSelectors } from 'selectors'

type State = {
	modal?: HTMLElement
}

export const DatamapImport = (() => {
	const { state, setState } = useState<State>()

	const handleModalOpen = (showModalOverview?: boolean) => {
		const { modal } = state
		if (!modal) {
			return
		}

		const instanceModal = M.Modal.init(modal, { startingTop: '20%', endingTop: '20%' })
		if (!instanceModal) {
			return
		}

		if (showModalOverview) {
			instanceModal.open()
		}
	}

	const init = (showModalOverview?: boolean) => {
		setState({ ...getImportDatamapSelectors() })
		handleModalOpen(showModalOverview)
	}

	return {
		init,
	}
})()
